interface PillarItem {
  icon?: string;
  title: string;
  titleHighlight?: string;
  highlightColor?: "blue" | "amber" | "green" | "orange";
  description: string;
}

interface PillarsBandProps {
  pillars: PillarItem[];
}

/**
 * PillarsBand
 *
 * 3-column highlights row used by `pillars`-style sections. Each pillar
 * has a title, optional accent-coloured fragment (`titleHighlight`) and a
 * supporting description sentence — designed to sit directly under a
 * hero or major section to ground the value proposition.
 */
export default function PillarsBand({ pillars }: PillarsBandProps) {
  if (!Array.isArray(pillars) || pillars.length === 0) {
    throw new Error("PillarsBand: `pillars` array is empty or invalid.");
  }

  return (
    <div className="pillars-band">
      {pillars.map((pillar) => (
        <article className="pillar" key={pillar.title}>
          <h3>
            {pillar.title}
            {pillar.titleHighlight ? (
              <>
                {" "}
                <span
                  className={`pillar-highlight pillar-highlight-${
                    pillar.highlightColor ?? "blue"
                  }`}
                >
                  {pillar.titleHighlight}
                </span>
              </>
            ) : null}
          </h3>
          <p>{pillar.description}</p>
        </article>
      ))}
    </div>
  );
}
